<template>
  <div class="background-03">

    <v-layout row wrap>
      <v-flex xs12 sm9 class="animated fadeInUp dura_1">
        <ui-title-red textTitle=" ¡Excelente!"></ui-title-red>
      </v-flex>
      <v-flex xs12 sm2 md2 class="hidden-xs-only aligner">
        <image-app class="animated fadeInRight" :imaSize="300" imaSrc="design/banco4-2-3" imaAlt=""></image-app>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc  :vidTittle="'Gastos fijos, gastos variables y gastos opcionales.'" videoEmbed="ADMINISTRACIONDINERO31GastosFijosVariablesOcasionales.mp4"></ui-simple-lsc>
      </v-flex>
      <v-flex xs12 md6 class="animated fadeInUp dura_2 aligner">
        <p class="text-box adorn-bottom">
         Ahora que tiene claros los diferentes tipos de gasto, está listo para continuar con su presupuesto.<br><br>
         A continuación se presentan tres cuadros en los que podrá ingresar los datos de sus gastos fijos, gastos variables y gastos opcionales.
        </p>
      </v-flex>
      <v-flex xs12 sm5 md5 text-xs-center class="aligner animated fadeIn dura_2">
        <image-app :imaSize="230" imaSrc="contenido/diapositiva_10" imaAlt="Mujer sonriendo recostada en el cuadro de texto"></image-app>
      </v-flex>
    </v-layout>

  </div>
</template>


<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.$store.commit("nextShow", true);
  }
};
</script>



// WEBPACK FOOTER //
// davivienda-31.vue?2b142f4a